import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/noticia';

export default {
    buscarNoticias() {
        return http.get({
            url: baseUrl,
            lockScreen: false
        });
    },

    buscarNoticiasPaginadas({page = 0, filter = '', order = null}) {
        return http.get({
            url: baseUrl + `/list/?page=${page}&filter=${filter}&order=${order}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoNoticias')
        });
    },

    buscarNoticiaPeloId(idNoticia) {
        return http.get({
            url: baseUrl + `/${idNoticia}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoNoticias')
        });
    },

    inativarNoticia(idNoticia, ativo) {
        return http.delete({
            url: baseUrl + `/${idNoticia}`,
            lockScreen: true,
            lockMessage: ativo ? i18n.t('mensagens.sistema.inativandoNoticia') : i18n.t('mensagens.sistema.ativandoNoticia')
        });
    },

    cadastrarNoticia(noticia) {
        return http.post({
            url: baseUrl + '/cadastrar',
            data: { ...noticia },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.noticias.cadastroNoticia.adicionandoNoticia')
        });
    },

    editarNoticia(editarNoticia, idNoticia) {
        return http.put({
            url: baseUrl + `/${idNoticia}`,
            data: editarNoticia,
            lockScreen: false
        });
    }

};
